import { useSearchParams } from "react-router-dom";
import { WithAuthorization } from "../../../context";
import { CSRDQuestionnaire } from "./index";

function CSRDQuestionnaireWrapper() {
  const [searchParams] = useSearchParams();
  const questionnaireId = searchParams.get("id");

  return (
    <CSRDQuestionnaire questionnaireId={questionnaireId} isOpenedInModal={false} />
  )
}

export default WithAuthorization(CSRDQuestionnaireWrapper);